import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import './index.css';

// Auth pages
import Login    from './pages/Login';
import Register from './pages/Register';

// Layout
import Layout from './components/Layout';

// Member pages
import MemberDashboard  from './pages/member/Dashboard';
import MemberWorkouts   from './pages/member/Workouts';
import MemberNutrition  from './pages/member/Nutrition';
import MemberProgress   from './pages/member/Progress';
import MemberClasses    from './pages/member/Classes';
import MemberProfile    from './pages/member/Profile';
import MemberCheckin    from './pages/member/Checkin';

// Admin pages
import AdminDashboard   from './pages/admin/Dashboard';
import AdminMembers     from './pages/admin/Members';
import AdminMemberView  from './pages/admin/MemberView';
import AdminPlans       from './pages/admin/Plans';
import AdminAttendance  from './pages/admin/Attendance';
import AdminClasses     from './pages/admin/Classes';
import AdminAnnounce    from './pages/admin/Announcements';

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-wrap"><div className="spinner"></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-wrap"><div className="spinner"></div></div>;
  if (!user) return <Navigate to="/login" />;
  if (user.role === 'admin') return <Navigate to="/admin/dashboard" />;
  return <Navigate to="/dashboard" />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"         element={<RootRedirect />} />
          <Route path="/login"    element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Member routes */}
          <Route path="/" element={<PrivateRoute roles={['member','trainer']}><Layout /></PrivateRoute>}>
            <Route path="dashboard"  element={<MemberDashboard />} />
            <Route path="workouts"   element={<MemberWorkouts />} />
            <Route path="nutrition"  element={<MemberNutrition />} />
            <Route path="progress"   element={<MemberProgress />} />
            <Route path="classes"    element={<MemberClasses />} />
            <Route path="checkin"    element={<MemberCheckin />} />
            <Route path="profile"    element={<MemberProfile />} />
          </Route>

          {/* Admin routes */}
          <Route path="/admin" element={<PrivateRoute roles={['admin']}><Layout isAdmin /></PrivateRoute>}>
            <Route path="dashboard"         element={<AdminDashboard />} />
            <Route path="members"           element={<AdminMembers />} />
            <Route path="members/:id"       element={<AdminMemberView />} />
            <Route path="plans"             element={<AdminPlans />} />
            <Route path="attendance"        element={<AdminAttendance />} />
            <Route path="classes"           element={<AdminClasses />} />
            <Route path="announcements"     element={<AdminAnnounce />} />
          </Route>

          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
